// This component is no longer needed since user activity tracking was removed
export function SessionTracking() {
  return null;
} 